import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { savePaymentMethod } from '../paymentMethod';

type PaymentType = 'PAYPAL';

type Params = {
	paymentType: PaymentType;
	token: string;
	email: string;
	usage: 'OFF_SESSION' | 'ON_SESSION';
	utilityContext: UtilityContext;
	firstName?: string;
	lastName?: string;
};

export async function saveBraintreePaymentMethod({
	token,
	email,
	usage,
	utilityContext,
	paymentType,
	firstName,
	lastName,
}: Params): Promise<void> {
	await savePaymentMethod({
		input: {
			customer: { email, firstName, lastName },
			gateway: 'BRAINTREE',
			usage,
			token,
			type: paymentType,
			gatewayData: null,
		},
		utilityContext,
	});
}
